import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import BackGroundColor from "../CommanComponents/BackGroundColor";
import api from "../utils/api";

function ResetPassword() {
  const { token } = useParams(); // URL'deki :token kısmını alır
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = async (values) => {
    setLoading(true);
    try {
      const res = await api.post(`reset_password/${token}`, {
        password: values.password,
      });

      if (res.status === 200) {
        alert("Şifreniz başarıyla güncellendi! Giriş yapabilirsiniz.");
        navigate("/login");
      }
    } catch (error) {
      alert(error.response?.data?.message || "Bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "", // Şifre onayı eklemek UX açısından iyidir
    },
    onSubmit: submit,
  });

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-yellow-100 relative overflow-hidden">
      <BackGroundColor />
      <div className="z-10 bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <h1 className="text-3xl text-blue-600 font-bold mb-2">
            My Classroom
          </h1>
          <p className="text-lg text-purple-500 font-semibold">New Password</p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2 w-full">
            <label className="block text-lg font-bold text-orange-500">
              New Password
            </label>
            <input
              type="password"
              name="password"
              value={values.password}
              onChange={handleChange}
              className="w-full h-12 text-xl rounded-full px-4 outline-none border-2 border-purple-300 focus:border-purple-500"
              placeholder="******"
              required
            />
          </div>

          <div className="w-full mt-4">
            <button
              className="bg-green-500 hover:bg-green-600 text-white text-xl font-bold rounded-full w-full h-12 transition-colors flex items-center justify-center"
              type="submit"
              disabled={loading}
            >
              {loading ? "Güncelleniyor..." : "Şifreyi Güncelle"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
